module.exports = __webpack_public_path__ + "img/3c.f494b5c2.png";